var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"async-load-err"},[_c('Hint',[_c('span',[_vm._v("请求页面加载失败")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.attemptReload}},[_vm._v("重新加载")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }